export default {
  'productCards.learnMore': '了解更多',
};
